import React from 'react';
import styles from './NodeModal.module.css';
import { UserInterface } from '../../../features/admin/user/domain';
import { Row } from '../../atoms/Row/Row';

import useRegistration from '../../../features/registration/application/useRegistration';

interface NodeModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: UserInterface;
}

export const NodeModal: React.FC<NodeModalProps> = ({ isOpen, onClose, data }) => {
    const { data: registrationData } = useRegistration();
    if (!isOpen || !data) return null;

    return (
        <div className={styles.modalBackdrop} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h3>Detalles del Usuario</h3>
                    <button className={styles.closeButton} onClick={onClose}>&times;</button>
                </div>
                <div className={styles.modalBody}>
                    <Row keyValue="Nombre" value={data.name} />
                    {data.email && <Row keyValue="Email" value={data.email} />}
                    {data.phone && <Row keyValue="Telefono" value={data.phone} />}
                    {data.ageRange && <Row keyValue="Edad" value={data.ageRange} />}
                    {data.gender && <Row keyValue="Genero" value={data.gender == 'male' ? 'Masculino' : 'Femenino'} />}
                    {data.department && data.city && <Row keyValue="Ubicación" value={data.department.name + ', ' + data.city.name} />}
                    {data.topicInterest && <Row keyValue="Interes" value={registrationData.topicsInterest.find((topic) => topic.id === data.topicInterest)?.name || ""} />}
                </div>
            </div>
        </div>
    );
};
